
async function simpleCallRpc(userContext, isRequestToMasterDB, endpoint, body) {
    let link = null;
    if (isRequestToMasterDB) link = '/api/rpc/';
    else link = '/api/data/rpc/';

    let timezone = 'Europe/Moscow'
    try { timezone = Intl.DateTimeFormat().resolvedOptions().timeZone } catch {}

    //console.log('userContext',userContext)
    try {
        const response = await
        fetch(link + endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
                tguser: encodeURIComponent(JSON.stringify({...userContext?.tguser})),
                timezone: timezone,
                workspacehash: userContext?.selected_workspace?.workspace_hash,
                contentwidth: window?.screen?.width,
                contentheight: window?.screen?.height,
                theme: userContext?.colorScheme
            },
            body: JSON.stringify({...body}),
            json: true,
        });
        const status = await response.status;
        if (status === 401) {
            return {}
        }
        if (status === 204) {
            return {}
        }
        const result = await response.json();
        return result;
    } catch (error) {
        console.error('Ошибка:', error);
        return {};
    }
}

export { simpleCallRpc }
